<template>
    <div>
        <b-card :style="{'max-width': '2000px', 'width': '1500px', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
            <b-card-text>
                <h4>Customer Deliveries</h4>
            </b-card-text>

            <b-card class="text-monospace">
                <div style="margin-left: auto; width: 300px;">
                    <div><b>Truck Totals</b></div>
                    <b-list-group>
                        <b-list-group-item v-for="truck,tidx in Object.keys(truck_cubes)" v-bind:key="tidx" style="font-size: 12px;">{{ packet.trucksdict[truck] }}  ({{ truck_cubes[truck] }} cubes)</b-list-group-item>
                    </b-list-group>
                </div>
            </b-card>

            <b-card-group>

                <b-card style="max-width: 200px; max-height: 1000px; overflow: scroll; margin-bottom: 10px;">
                    <b-button variant="outline-success" @click="fetch_data({'date': null})">ALL</b-button>
                    <b-button v-for="dt,idx in date_counts" v-bind:key="idx" style="margin: 5px;" variant="outline-primary" @click="fetch_data({'date': dt.value})" :pressed="delivery_date == dt.value">
                        {{ dt.text }}
                    </b-button>
                </b-card>
                <b-card>
                    <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                        <div v-if="items.length > 0" style="margin-top: 10px; max-height: 2000px; overflow-y: scroll;">
                            <div style="text-align: right;"><b-button size="sm" @click="fetch_data({'date': delivery_date})">Reload</b-button></div>
                            <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                            <thead>
                                <tr style="background: #c3cdd3;">
                                    <td class="ipt_tdhr">
                                        # 
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('order_invoice_id')">
                                        INV ID
                                    </td>
                                    <td class="ipt_tdhr" style="width: 100px;">
                                        DELIVERY DATE
                                    </td>
                                    <td class="ipt_tdhr">
                                        TRUCK
                                    </td>
                                    <td class="ipt_tdhr" style="width: 80px;" v-on:click="sortby('zipcode')">
                                        ZIPCODE
                                    </td>
                                    <!-- <td class="ipt_tdhr" style="width: 250px;" v-on:click="sortby('locsub')">
                                        FULFILL FRM
                                    </td> -->
                                    <td class="ipt_tdhr" style="width: 250px;" v-on:click="sortby('truck_pick_locations')">
                                        TRUCK PICKUP LOC
                                    </td>
                                    <!-- <td class="ipt_tdhr" style="width: 200px;">
                                        CUSTOMER
                                    </td> -->
                                    <td class="ipt_tdhr" style="width: 250px;">
                                        ITEMS
                                    </td>
                                    <td class="ipt_tdhr" style="width: 40px;" v-on:click="sortby('total_cubes')">
                                        TOTAL CUBES
                                    </td>
                                    
                                    <!-- <td class="ipt_tdhr" style="width: 200px;">
                                        COMMENTS
                                    </td> -->
                                    <td class="ipt_tdhr">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item,idx in items" v-bind:key="idx">
                                    <td class="ipt_tdhr">
                                        {{ idx + 1 }}
                                    </td>
                                    <td class="ipt_tdhr" @click="navigateToInvoice(item.invoice_id)" style="background: #efefef; padding: 3px; width: 180px;">
                                        {{ item.order_invoice_id }}
                                    </td>
                                    <td class="ipt_tdhr">
                                        <flat-pickr v-model="item.delivery_date" :config="{ dateFormat: 'Y-m-d', mode: 'single' }" style="font-size: 11px; text-align: center; border: 1px solid cornflowerblue; padding: 3px; width: 100px;"></flat-pickr>
                                    </td>
                                    <td class="ipt_tdhr">
                                        <b-form-select size="sm" :options="packet.trucks" v-model="item.truck" style="font-size: 10px; width: 100px; border: 1px solid cornflowerblue;" v-on:change="calculate_truck_totals2"></b-form-select>
                                    </td>
                                    <td class="ipt_tdhr">
                                        <div>{{item.zipcode}}</div>
                                    </td>
                                    <!-- <td class="ipt_tdhr">
                                        <div>{{packet.locsubsdict[item.locsub]}}</div>
                                    </td> -->
                                    <td class="ipt_tdhr">
                                        <div>{{item.truck_pick_locations}}</div>
                                    </td>
                                    <td class="ipt_tdhr" style="font-size: 11px; font-weight: normal;">
                                        <div>
                                            <div style="display: inline-block; width: auto;">
                                            </div>
                                            <div style="display: inline-block; width: auto;">
                                                <div v-if="!item.items_shown">
                                                    <b-button size="sm" style="font-size: 12px; font-weight: bold;" variant="outline-primary" @click="show_items(item)">{{ item.elements.length }} ITEMS</b-button>
                                                </div>
                                                <div v-else>
                                                    <b-button size="sm" style="font-size: 10px;" variant="outline-danger" @click="hide_items(item)">HIDE</b-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="margin-top: 5px;" v-if="item.items_shown">
                                            <div v-for="element,eidx in item.elements" v-bind:key="eidx">
                                                <div style="padding: 3px; background: aliceblue; margin: 5px; border: 1px solid gray;">
                                                    {{element.product_sku }} X ({{ element.quantity }})

                                                    <div style="display: inline-block;">
                                                        <b-form-select size="sm" v-model="element.truck" :options="packet.trucks" style="font-size: 10px;" v-on:change="calculate_truck_totals"></b-form-select>

                                                        <flat-pickr v-model="element.delivery_date" :config="{ dateFormat: 'Y-m-d', mode: 'single' }" style="font-size: 11px; text-align: center; border: 1px solid cornflowerblue; padding: 3px; width: 100%;"></flat-pickr>

                                                        <div syle="margin-top: 5px;">{{element.merchandise_status}}</div>

                                                        <div style="margin-top: 5px;">
                                                            <b-button size="sm" style="font-size: 10px;" variant="success" @click="update_single_item(element)">
                                                                UPDATE ITEM
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    
                                                </div>

                                            </div>
                                        </div>
                                    </td>
                                    <td class="ipt_tdhr">
                                        {{ item.total_cubes }}
                                    </td>
                                    
                                    <td class="ipt_tdhr" style="width: 100px;">
                                        <b-button size="sm" variant="primary" @click="update_delivery_items(item, fetch_data, {date: delivery_date})" :disabled="update_disabled">UPDATE</b-button>
                                    </td>
                                </tr>
                            </tbody>
                            </table>      
                        </div>
                        <div v-else>
                            <b-alert show variant="warning">Select a date</b-alert>
                            
                        </div>
                    </b-overlay>
                </b-card>
            </b-card-group>
        </b-card>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "AdminToolsHomeDeliveries",
        components: {Backer, flatPickr},
        data: function() {
            return {
                sort_asc: true,
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                delivery_date: null,
                update_disabled: false,
                states: [
                    {"value": null, "text": "NONE"},
                    {"value": "atpl", "text": "ADDED TO PULLIST"},
                    {"value": "pulled", "text": "PULLED"},
                    {"value": "picked", "text": "PICKED"},
                    {"value": "dropped", "text": "DROPPED"},
                    {"value": "rts", "text": "READY TO SHIP"},
                    {"value": "shipped", "text": "SHIPPED"},
                    {"value": "delivered", "text": "DELIVERED"},
                    {"value": "completed", "text": "COMPLETED"},
                ],
                statesdict: {
                    null: "NONE",
                    "atpl": "ADDED TO PULLIST",
                    "pulled": "PULLED",
                    "picked": "PICKED",
                    "dropped": "DROPPED",
                    "rts": "READY TO SHIP",
                    "shipped": "SHIPPED",
                    "delivered": "DELIVERED",
                    "completed": "COMPLETED",
                },
                truck_cubes: {},
                date_counts: []
            }
        },
        methods: {
            show_items: function(item){
                item.items_shown = true;
            },
            hide_items: function(item){
                item.items_shown = false;
            },
            calculate_truck_totals: function(){
                let output = {};
                for (var i=0; i<this.items.length; i++){
                    for (var j=0; j<this.items[i].elements.length; j++){
                        let truck = this.items[i].elements[j].truck;
                        if (truck){
                            let cubes = this.items[i].elements[j].cubes;
                            if (truck in output){
                                output[truck] += cubes;
                            }
                            else {
                                output[truck] = cubes;
                            }
                        }
                    }
                }
                this.truck_cubes = output
            },
            calculate_truck_totals2: function(){
                let output = {};
                for (var i=0; i<this.items.length; i++){
                    let truck = this.items[i].truck;
                    for (var j=0; j<this.items[i].elements.length; j++){
                        if (truck){
                            let cubes = this.items[i].elements[j].cubes;
                            if (truck in output){
                                output[truck] += cubes;
                            }
                            else {
                                output[truck] = cubes;
                            }
                        }
                    }
                }
                this.truck_cubes = output
            },
            update_single_item: function(element){
                let item = {
                    delivery_date: element.delivery_date,
                    truck: element.truck,
                    elements: [element],
                    invoice_id: element.invoice_id
                };

                this.update_delivery_items(item, this.fetch_data, {date: this.delivery_date});

            },
            update_delivery_items: function(item, callback, callback_params){
                let that = this;
                let delivery_date = item.delivery_date;
                let truck = item.truck;

                item.elements = item.elements.map(function(d){
                    d.delivery_date = delivery_date;
                    d.truck = truck;
                    return d
                });

                let data = {items: item.elements, invoice_id: item.invoice_id, comment_txt: item.comment_txt}
                let path = "/api/transfers/update_delivery_items/"
                let s = function(response) {
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        if (callback){
                            that.fetch_init()
                            callback(callback_params);

                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.update_disabled = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.update_disabled = false
                }
                this.update_disabled = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_data: function(params){
                let that = this;
                this.delivery_date = params.date;
                let data = {delivery_date: this.delivery_date}
                let path = "/api/transfers/get_home_deliveries/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        that.calculate_truck_totals();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_init: function(){
                let that = this;
                let data = {type: "home_delivery"}
                let path = "/api/transfers/get_deliveries_counts/"
                let s = function(response) {
                    if (response.data.result){
                        that.date_counts = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                this.date_counts = []
                Requestor.getAsyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
            navigateToInvoice: function(invoice_id){
                let route = this.$router.resolve({path: "/sales/viewsale/"+invoice_id+"/"});
                window.open(route.href, '_blank');
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_init()
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsHomeDeliveries.vue